import { render, staticRenderFns } from "./NewClassroom.vue?vue&type=template&id=044da484"
import script from "./NewClassroom.vue?vue&type=script&lang=js"
export * from "./NewClassroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports